// The walkthrough controller's context, apart from WalkthroughProvider so a
// hook can read the run without importing the provider's page-tool and help
// modules (that import closed a cycle through the agent chat page).
import { createContext, useContext } from 'react'
import type { TourState } from './tourRuntime'

export interface WalkthroughContextValue {
  /** Start a walkthrough at its first step (Admin → Walkthroughs). */
  start: (slug: string) => void
  /** The run in progress, if any. */
  state: TourState
  /** The run as it is now, for a handler: a step's click can land before `state` re-renders. */
  current: () => TourState
  /** Slugs finished in this browser. */
  done: string[]
}

export const WalkthroughContext = createContext<WalkthroughContextValue | null>(null)

/** The walkthrough controller, or null outside the provider. */
export function useWalkthrough(): WalkthroughContextValue | null {
  return useContext(WalkthroughContext)
}

/** The slug of the walkthrough a run belongs to; undefined for a Help pane tour or no run. */
export function walkthroughSlugOf(state: TourState | undefined): string | undefined {
  const id = state?.tour?.id
  return id?.startsWith('walkthrough:') ? id.slice('walkthrough:'.length) : undefined
}
